export class QuestionsModel {
  id: number;
  reasonId: number;
  questionText: string;
  isValid: boolean;
  defaultAnswer: any;
  errorMessage: string;
  questionClass: number;
  questionType: number;
  answerSelected: any;
  answers: Array<{
    answerAction: number;
    id: number;
    answerText: string;
  }>;
  isCompulsary: boolean;
  recommendedAnswerId?: number;
}
